export default "__VITE_ASSET__DfpONsJb__"